import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=3fa0f088&scoped=true"
import script from "./ContextMenuItem.vue?vue&type=script&lang=js"
export * from "./ContextMenuItem.vue?vue&type=script&lang=js"
import style0 from "./ContextMenuItem.vue?vue&type=style&index=0&id=3fa0f088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa0f088",
  null
  
)

export default component.exports